import React from 'react';
import {
  PlayArrow as PlayIcon,
  Close as CloseIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  GetApp as DownloadIcon,
} from '@material-ui/icons';
import styles from './VideoPanel.module.css';

const VideoPanel = ({
  formatFileSize,
  selectedVideos = [],
  onClearSelection,
  onPlayVideo,
  onEditVideo,
  onDeleteVideo,
  onDownloadVideo,
  selectedItems,
  setOpenEditInBulk,
  tabTitle
}) => {
  const videoCount = selectedItems.length;
  const firstVideo = selectedItems[0];
  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>
            {tabTitle === 0
              ? (videoCount === 1 ? 'Video Selected' : `${videoCount} Videos Selected`)
              : (videoCount === 1 ? 'Album Selected' : `${videoCount} Albums Selected`)}
          </h2>
          <button
            className={styles.closeButton}
            onClick={onClearSelection}
            title="Clear selection"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className={styles.content}>
        {videoCount === 1 && firstVideo ? (
          // Single video preview
          <div className={styles.videoPreview}>
            <div className={styles.thumbnailContainer}>
              <img
                src={firstVideo.thumbnail_url || firstVideo.presigned_url || firstVideo.thumbnail || firstVideo.thumbnails}
                alt={firstVideo.title || 'Video thumbnail'}
                className={styles.thumbnail}
                onError={(e) => {
                  e.target.src = '/Assets/no-image-available.png';
                }}
              />
              {/* <button
                className={styles.playButton}
                onClick={() => onPlayVideo(firstVideo)}
                title="Play video"
              >
                <PlayIcon />
              </button> */}
            </div>
            {tabTitle === 0 && (
            <div className={styles.videoInfo}>
              <h3 className={styles.videoTitle}>
                {firstVideo.title || 'Untitled Video'}
              </h3>

                <div className={styles.videoDetails}>
                  {firstVideo.video_duration !== null && (
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>Duration:</span>
                    <span className={styles.detailValue}>
                    {firstVideo.video_duration || 'Unknown'}
                    </span>
                </div>
                  )}
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>Size:</span>
                    <span className={styles.detailValue}>
                      {formatFileSize(firstVideo.file_size || firstVideo.video_size)}
                    </span>
                </div>

                {/* <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>Status:</span>
                  <span className={`${styles.detailValue} ${styles.statusBadge} ${firstVideo.status === 'processed' ? styles.processed : styles.processing}`}>
                    {firstVideo.status || 'Unknown'}
                  </span>
                </div> */}

{(firstVideo?.created_at || firstVideo?.created) && (
  <div className={styles.detailItem}>
    <span className={styles.detailLabel}>Published:</span>
    <span className={styles.detailValue}>
      {(() => {
        const date = new Date(firstVideo.created_at || firstVideo.created);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      })()}
    </span>
  </div>
)}
                </div>
            </div>
              )}
          </div>
        ) : videoCount > 1 ? (
          // Multiple videos with stacked thumbnails
          <div className={styles.multipleVideos}>
            <div className={styles.stackedThumbnails}>
              {selectedItems.slice(0, 3).map((video, index) => (
                <div
                  key={video.content_id || video.draft_id || video.video_id || index}
                  className={styles.stackedThumbnail}
                  style={{ zIndex: 3 - index, transform: `translateX(${index * 8}px) translateY(${index * 8}px)` }}
                >
                  <img
                    src={video.thumbnail_url || video.presigned_url || video.thumbnail || video.thumbnails}
                    alt={video.title || 'Video thumbnail'}
                    className={styles.stackedImage}
                    onError={(e) => {
                      e.target.src = '/Assets/no-image-available.png';
                    }}
                  />
                </div>
              ))}
              {videoCount > 3 && (
                <div className={styles.moreIndicator}>
                  +
                  {videoCount - 3}
                </div>
              )}
            </div>
            <div className={styles.summaryText}>
              <p className={styles.videoCount}>
                {videoCount}
                {' '}
                {tabTitle === 0 ? 'videos' : 'albums'}
                {' '}
                selected
              </p>
                {tabTitle === 0 && (

                  <p className={styles.summarySubtext}>
                Use the action buttons below to perform bulk operations
                  </p>
              )}
            </div>
          </div>
        ) : null}

        {/* Action Buttons */}
        <div className={styles.actions}>
          {videoCount === 1 && (
            <>
              {/* <button
                className={`${styles.actionButton} ${styles.playButton}`}
                onClick={() => onPlayVideo(firstVideo)}
                title="Play video"
              >
                <PlayIcon />
                <span>Play</span>
              </button> */}

              <button
                className={`${styles.actionButton} ${styles.editButton}`}
                onClick={() => onEditVideo(firstVideo)}
                title="Edit video"
              >
                <EditIcon />
                <span>Edit</span>
              </button>
            </>
          )}

          {/* <button
            className={`${styles.actionButton} ${styles.downloadButton}`}
            onClick={() => onDownloadVideo(selectedItems)}
            title={videoCount === 1 ? 'Download video' : 'Download videos'}
          >
            <DownloadIcon />
            <span>Download</span>
          </button> */}

          <button
            className={`${styles.actionButton} ${styles.deleteButton}`}
            onClick={() => onDeleteVideo(selectedItems)}
            title={videoCount === 1 ? 'Delete video' : 'Delete videos'}
          >
            <DeleteIcon />
            <span>Delete</span>
          </button>
          {selectedItems?.length > 1 && tabTitle === 0 && (
<button
            className={`${styles.actionButton} ${styles.EditInBulkButton}`}
            onClick={() => setOpenEditInBulk(true)}
            title={`Edit in ${videoCount} Videos`}
>
                        <EditIcon />
            <span>
Edit
{' '}
{videoCount}
{' '}
Videos
            </span>
</button>
)}
        </div>
      </div>
    </div>
  );
};

export default VideoPanel;
